import StoreSalesReportManagementPage from "./StoreSalesReportManagementPage";

export default StoreSalesReportManagementPage;
